export default `
  mutation SendWishlist($wishlistId: ID!, $emails: String!, $message: String!) {
    sendWishlist(wishlistId: $wishlistId, emails: $emails, message: $message) {
      status
      errors
      sent_emails
    }
  }
`;
